export default __webpack_public_path__ + "static/media/cloud-4-night.115f89fd.svg";